import { EntityMetadata } from '@ngrx/data';
import { HttpResourceUrls } from '@ngrx/data/src/dataservices/http-url-generator';
import { Message } from '../message.model';

export interface PatientMessageQueryFilter {
    personId: number;
    offset: number;
    totalLoaded: number;
    batchSize: number;
    lastUpdated: number;
}

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const patientMessageEntityMetadata: EntityMetadata<Message> = {
    entityName: 'PatientMessage',
    selectId: messageSelectId, // .id is used if doing optimistic update
    additionalCollectionState: {
        refreshing: false,
        queryFilter: {
            personId: undefined,
            offset: 0,
            totalLoaded: 0,
            lastUpdated: undefined,
            batchSize: undefined
        }
    }
    // https://stackoverflow.com/questions/62828590/how-to-extend-custom-entity-collection-reducers-in-ngrx-data

    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

export const accountMessageEntityMetadata: EntityMetadata<Message> = {
    entityName: 'AccountMessage',
    selectId: messageSelectId // .id is used if doing optimistic update
    // additionalCollectionState: {
    //     userId: 1 // extra properties
    // }
    // filterFn: nameFilter,
    // sortComparer: sortByName
    // entityDispatcherOptions: { optimisticAdd: true, optimisticUpdate: true }
};

export const patientMessageHttpResourceUrls: HttpResourceUrls = {
    entityResourceUrl : '/servlets/messages/person/entity/', // Not used
    collectionResourceUrl: '/servlets/messages/person/entity/' // Not used
};

// tslint:disable-next-line:only-arrow-functions typedef
export function messageSelectId<T extends { id: any }>(message: Message) {
    return  message === undefined ? undefined : message.id || message.messageId;  // .id is used if doing optimistic update
}

